import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import * as ThemeQueryField from '../constants/ThemeQueryField';
import * as AssetSort from '../common/constants/AssetSort';
export const THEME_QUERY_FIELD_NAMES = Object.values(ThemeQueryField);
export const THEME_QUERY_FILTER_ORDER = [ThemeQueryField.BUSINESS_TYPES, ThemeQueryField.PAGE_TYPES, ThemeQueryField.PAGE_FEATURES, ThemeQueryField.PLAN_TYPE, ThemeQueryField.PRICE_RANGE, ThemeQueryField.PORTAL_COMPATIBLE, ThemeQueryField.TIERS, ThemeQueryField.MIN_OVERALL_RATING, ThemeQueryField.HAS_FREE_SUPPORT, ThemeQueryField.PROVIDERS, ThemeQueryField.TAGS];
export const DEFAULT_THEME_QUERY_LIMIT = 24;
export const DEFAULT_THEME_SORT_VALUE = AssetSort.INSTALL_COUNT_DESC;
const defaults = {
  businessTypes: [],
  hasFreeSupport: null,
  languages: [],
  limit: DEFAULT_THEME_QUERY_LIMIT,
  minOverallRating: null,
  minReviewCount: null,
  offeringIds: [],
  offset: 0,
  pageFeatures: [],
  pageTypes: [],
  planType: null,
  portalCompatible: null,
  priceRange: null,
  providers: [],
  search: null,
  sortFields: [],
  tags: [],
  tiers: []
};
export class ThemeQuery extends createImmutableObjectClass(defaults) {}